import { ITool } from "../../models/Tool.model";

export const FakeTools: ITool[] = [
//   {
//     name: "Excel Tool",
//     functions: [
//         {
//     function: "extract_text_from_excel",
//     language: "python",
//     toolConfig: `def extract_text_from_excel(excel_path):
//     try:
//         # Load data from the first sheet
//         sheet_data = pd.read_excel(excel_path, sheet_name=0)
//         return sheet_data
//     except Exception as e:
//         logging.error(f"Failed to extract text from Excel: {e}")
//         raise`,
//         },
//         {
//             function: "parse_excel_text",
//             language: "python",
//             toolConfig: `def parse_excel_text(sheet_data):
//             try:
//                 structured_test_cases = {}
//                 last_test_id = None
//                 last_test_name = None
//                 last_description = None
        
//                 for _, row in sheet_data.iterrows():
//                     # Update the test ID, name, and description if they are not NaN
//                     if not pd.isna(row.get("TestID")):
//                         last_test_id = row.get("TestID")
//                     if not pd.isna(row.get("TestName")):
//                         last_test_name = row.get("TestName")
//                     if not pd.isna(row.get("Description")):
//                         last_description = row.get("Description")
        
//                     # Create a unique key for each test case
//                     test_key = (last_test_id, last_test_name, last_description)
        
//                     # Initialize the test case entry if it doesn't exist
//                     if test_key not in structured_test_cases:
//                         structured_test_cases[test_key] = {
//                             "TestID": last_test_id,
//                             "TestName": last_test_name,
//                             "Description": last_description,
//                             "Steps": []
//                         }
        
//                     # Check if all StepName, StepAction, and ExpectedResult are NaN
//                     if pd.isna(row.get("StepName")) and pd.isna(row.get("StepAction")):
//                         continue  # Skip adding this step
        
//                     # Append the step details to the Steps array
//                     step_details = {
//                         "StepName": row.get("StepName"),
//                         "StepAction": row.get("StepAction"),
//                         "ExpectedResult": row.get("ExpectedResult")
//                     }
//                     structured_test_cases[test_key]["Steps"].append(step_details)
        
//                 # Convert the dictionary to a list of structured test cases
//                 return list(structured_test_cases.values())
//             except Exception as e:
//                 logging.error(f"Failed to parse Excel text: {e}")
//                 raise`,
//           }],
//     description:
//       "This tool extracts text content from an Excel file, allowing data from structured tables or cells to be processed in the workflow. It reads the file located at the provided path and outputs the extracted data for further parsing.",
//     logo: "/assets/images/randon-logo.png",
//   },
//   {
//     name: "Parsing Tool",
//     functions: [
//         {
//     function: "parse_excel_text",
//     language: "python",
//     toolConfig: `def parse_excel_text(sheet_data):
//     try:
//         structured_test_cases = {}
//         last_test_id = None
//         last_test_name = None
//         last_description = None

//         for _, row in sheet_data.iterrows():
//             # Update the test ID, name, and description if they are not NaN
//             if not pd.isna(row.get("TestID")):
//                 last_test_id = row.get("TestID")
//             if not pd.isna(row.get("TestName")):
//                 last_test_name = row.get("TestName")
//             if not pd.isna(row.get("Description")):
//                 last_description = row.get("Description")

//             # Create a unique key for each test case
//             test_key = (last_test_id, last_test_name, last_description)

//             # Initialize the test case entry if it doesn't exist
//             if test_key not in structured_test_cases:
//                 structured_test_cases[test_key] = {
//                     "TestID": last_test_id,
//                     "TestName": last_test_name,
//                     "Description": last_description,
//                     "Steps": []
//                 }

//             # Check if all StepName, StepAction, and ExpectedResult are NaN
//             if pd.isna(row.get("StepName")) and pd.isna(row.get("StepAction")):
//                 continue  # Skip adding this step

//             # Append the step details to the Steps array
//             step_details = {
//                 "StepName": row.get("StepName"),
//                 "StepAction": row.get("StepAction"),
//                 "ExpectedResult": row.get("ExpectedResult")
//             }
//             structured_test_cases[test_key]["Steps"].append(step_details)

//         # Convert the dictionary to a list of structured test cases
//         return list(structured_test_cases.values())
//     except Exception as e:
//         logging.error(f"Failed to parse Excel text: {e}")
//         raise`,
//   }],
//     description:
//       "The Parsing Tool processes the raw text data extracted from the Excel file. It organizes and structures the extracted information into a format that is more accessible and usable for downstream steps, such as generating reports or creating test cases.",
//     logo: "/assets/images/randon-logo.png",
//   },

//   {
//     name: "File Writing Tool - Test Case",
//     functions: [
//         {
//     function: "write_test_cases_to_txt",
//     language: "python",
//     toolConfig: `def write_test_cases_to_txt2(structured_test_cases, txt_output_path):
//     try:
//         # Ensure the output directory exists
//         os.makedirs(txt_output_path, exist_ok=True)

//         for test_case in structured_test_cases:
//             # Generate the filename using TestID and TestName
//             test_id = test_case["TestID"]
//             test_name = test_case["TestName"]
//             filename = f"{test_id}_{test_name}.txt"
//             filepath = os.path.join(txt_output_path, filename)

//             # Write the test case details to the file
//             with open(filepath, 'w') as file:
//                 file.write(f"TestID: {test_case['TestID']}")
//                 file.write(f"TestName: {test_case['TestName']}")
//                 file.write(f"Description: {test_case['Description']}")
//                 file.write("Steps:")
//                 for step in test_case['Steps']:
//                     file.write(f"  StepName: {step['StepName']}")
//                     file.write(f"  StepAction: {step['StepAction']}")
//                     file.write(f"  ExpectedResult: {step['ExpectedResult']}")
//                     file.write("")  # Add a blank line between steps

//     except Exception as e:
//         logging.error(f"Failed to write test cases to txt: {e}")
//         raise`,
//         }],
//     description:
//       "The File Writing Tool provides multiple functions for writing and storing structured test data into different formats, including TXT, README, and Excel. It enables easy storage and retrieval of formatted test cases, summaries, and other relevant data.",
//     logo: "/assets/images/randon-logo.png",
//   },

//   {
//     name: "File Writing Tool - Test Case Analysis",
//     functions: [
//         {
//     function: "generate_test_case_analysis_llm",
//     language: "python",
//     toolConfig: `def generate_test_case_analysis_llm(structured_test_cases, readme_output_path):
//     try:
//         # Ensure the output directory exists, create it if it doesn't exist
//         os.makedirs(readme_output_path, exist_ok=True)
//         test_case_analysis_chain = get_chain(test_case_analysis_template)
//         for test_case in structured_test_cases:
//             # Generate the README content for the current test case
//             readme_result = ""
//             for tok in test_case_analysis_chain.stream({"test_scenario": [test_case]}):
//                 print(tok, end="", flush=True)
//                 readme_result += tok

//             # Generate the filename using TestID and TestName
//             test_id = test_case["TestID"]
//             test_name = test_case["TestName"]
//             filename = f"{test_id}_{test_name}_README.md"
//             sanitized_filename = re.sub(r'[\\/*?:"<>|]', "_", filename)
//             filepath = os.path.join(readme_output_path, sanitized_filename)

//             # Write the README content to the file
//             with open(filepath, 'w') as file:
//                 file.write(readme_result)

//     except Exception as e:
//         logging.error(f"Failed to generate README files: {e}")
//         raise`,
//         }],
//     description:
//       "The File Writing Tool provides multiple functions for writing and storing structured test data into different formats, including TXT, README, and Excel. It enables easy storage and retrieval of formatted test cases, summaries, and other relevant data.",
//     logo: "/assets/images/randon-logo.png",
//   },

//   {
//     name: "File Writing Tool - Excel Sheet Generator",
//     functions: [
//         {
//     function: "generate_excel_sheet_for_test_cases",
//     language: "python",
//     toolConfig: `def generate_excel_sheet_for_test_cases(test_cases_path, excel_input_path, excel_output_path, test_cases_sheet_name, test_scenarios_json_path):
//         import pandas as pd
//         import os
//         try:
//             # Load the main test cases from the Excel file
//             test_cases_df = pd.read_excel(test_cases_path, sheet_name=test_cases_sheet_name)
            
//             # If an input Excel file with additional data is provided, load it
//             additional_data_df = pd.read_excel(excel_input_path) if os.path.exists(excel_input_path) else None
            
//             # If a JSON file with test scenarios is provided, load it
//             test_scenarios_df = pd.read_json(test_scenarios_json_path) if os.path.exists(test_scenarios_json_path) else None
            
//             # Create a new Excel writer object to save the output
//             output_filepath = os.path.join(excel_output_path, f"{test_cases_sheet_name}_output.xlsx")
//             with pd.ExcelWriter(output_filepath) as writer:
//                 # Write the main test cases to a sheet
//                 test_cases_df.to_excel(writer, sheet_name="TestCases", index=False)
                
//                 # Write additional data to another sheet if it exists
//                 if additional_data_df is not None:
//                     additional_data_df.to_excel(writer, sheet_name="AdditionalData", index=False)
                
//                 # Write test scenarios to another sheet if it exists
//                 if test_scenarios_df is not None:
//                     test_scenarios_df.to_excel(writer, sheet_name="TestScenarios", index=False)
            
//             logging.info(f"Excel file generated successfully at {output_filepath}")
//             return output_filepath
        
//         except Exception as e:
//             logging.error(f"Failed to generate Excel sheet for test cases: {e}")
//             raise`,
//         }],
//     description:
//       "The Excel Sheet Generator Tool creates a new Excel file with structured test case data based on input paths and configurations. It organizes test case information into specified sheets within the Excel file, allowing easy analysis and further use in downstream workflows.",
//     logo: "/assets/images/randon-logo.png",
//   },

//   {
//     name: "MongoDB Tool",
//     functions: [
//         {
//     function: "insert_test_case_data_to_mongodb",
//     language: "python",
//     toolConfig: `def insert_test_case_data_to_mongodb(readme_file_path, db_name, collection_name, connection_string, base_path):
//     try:
//         # Debugging: Print the received parameters
//         print(f"db_name: {db_name}, collection_name: {collection_name}, connection_string: {connection_string}")

//         # Establish a connection to the MongoDB server using the provided connection string
//         client = MongoClient(connection_string, tlsCAFile=certifi.where())

//         # Select the database
//         db = client[db_name]

//         # Select the collection
//         collection = db[collection_name]

//         # Get all the readme files in the given path
//         readme_files = glob.glob(os.path.join(readme_file_path, '*_README.md'))

//         # Extract Test Case data from each README file
//         for readme_file in readme_files:
//             test_data = {}
//             metadata = {}

//             # Get the excel file name from the folder name
//             test_case_filename =  os.path.basename(readme_file_path)

//             # Get the readme file name
//             readme_filename = Path(readme_file).name

//             # Create the id using the readme filename
//             doc_id = readme_filename.replace("_README.md", "")

//             # Store the metadata
//             metadata["base_path"] = base_path
//             metadata["relative_path"] = test_case_filename
//             metadata["readme_filename"] = readme_filename

//             # Extract the test case data from the readme file
//             print(f"\n\nExtracting Test Data from the README file: {Path(readme_file).name}")
//             json_output = extract_test_case_data_from_readme(readme_file)
//             extracted_data = json.loads(json_output)

//             # Store the id and filename in the test data
//             test_data["_id"] = doc_id
//             test_data["file_name"] = test_case_filename

//             # Store the extracted data in the test data
//             test_data.update(extracted_data)

//             # Store the metadata in the test data
//             test_data["metadata"] = metadata

//             # Debugging: Print the test data
//             print(f"\n Test data:\n{json.dumps(test_data, indent=4)}")

//             # Insert the document in MongoDB
//             result = collection.insert_one(test_data)

//             print(f"Document inserted with _id:{result.inserted_id}")

//         return {"status": "success", "message": "MongoDB update operation completed."}
    
//     except Exception as e:
//         raise ValueError(f"Failed to update MongoDB: {e}")`,
//         }],
//     description:
//       "This tool is responsible for updating MongoDB with structured test case data. It uses a connection string to connect to the MongoDB instance, and it stores the data in the specified collection and database, allowing for organized, queryable test case storage.",
//     logo: "/assets/images/randon-logo.png",
//   },

//   {
//     name: "Feature Generation Tool",
//     functions: [
//         {
//     function: "generate_tweaked_feature_file_llm",
//     language: "python",
//     toolConfig: `def generate_tweaked_feature_file_llm(structured_test_cases, pattern, feature_file_output_path, json_directory):
//     try:

//         # Get the json files in the given directory
//         json_files = glob.glob(os.path.join(json_directory, '*.json'))

//         # Store the json data in a dictionary
//         json_file_data = {}
//         test_case_ids = []
//         for json_file in json_files:
//             # Get the name of the json file
//             json_file_name = Path(json_file).name
//             # Read the json file and store the data in the dictionary
//             with open(json_file, 'r') as file:
//                 json_data = json.load(file)
//                 json_file_data[json_file_name] = json_data
//                 test_case_ids.append(json_data["test_case"])
        
//         print(f"\n\nThe json file data is:\n {json.dumps(json_file_data, indent=4)}")

//         # Ensure the output directory exists, create it if it doesn't exist
//         os.makedirs(feature_file_output_path, exist_ok=True)

//         # Initialize a dictionary to store generated feature file content for retrieval
//         generated_feature_files = {}

//         feature_file_generation_chain = get_chain(tweaked_feature_file_template)
//         for test_case in structured_test_cases:
//             # Generate the corresponding json filename using TestID and TestName
//             test_id = test_case.get("TestID", "UnknownID")          # Default to 'UnknownID' if TestID is missing
//             test_name = test_case.get("TestName", "UnknownTest")    # Default to 'UnknownTest' if TestName is missing
//             tc_json_filename = f"{test_id}_{test_name}.json"
//             # Store the test name and description
//             tc_details = test_case.get("TestName", "UnknownTest") + test_case.get("Description", "UnknownDescription")
//             # Get the TestID from the json data
//             tc_id = json_file_data.get(tc_json_filename, {}).get("test_case", "UnknownID")
//             print(f"\n\nGenerating Feature file for TestID: {tc_id}")
//             # Get the flow type from the json data
//             flow_type = json_file_data.get(tc_json_filename, {}).get("flow", "STP") 
//             # Get the Repair flow type from the test case name
//             if flow_type == "Repair":
//                 test_case_details = tc_details.lower()
//                 if "video" in test_case_details:
//                     flow_type = "Repair in MTS Video Screen"
//                 else:
//                     flow_type = "Repair in Control Centre"
//             print(f"\nThe test details are {tc_details}")
//             print(f"\nThe flow type is {flow_type}\n")
//             # Generate the Feature file content for the current test case
//             feature_file_result = ""
//             for tok in feature_file_generation_chain.stream({"test_case": [test_case], "pattern_file": pattern, "flow": flow_type}):
//                 print(tok, end="", flush=True)
//                 feature_file_result += tok

//             # Generate the filename using TestID and TestName
//             filename = f"{test_id}_{test_name}.feature"
//             sanitized_filename = re.sub(r'[\\/*?:"<>|]', "_", filename)
//             filepath = os.path.join(feature_file_output_path, sanitized_filename)

//             # Write the Feature file content to the file
//             with open(filepath, 'w') as file:
//                 file.write(feature_file_result)
//             # Store the result in the dictionary for retrieval
//             generated_feature_files[test_id] = {
//                 "test_name": test_name,
//                 "content": feature_file_result
//             }

//         # Return the dictionary of generated feature files
//         return generated_feature_files
//     except Exception as e:
//         logging.error(f"Failed to generate Feature files: {e}")
//         raise
// `,
//         }],
//     description:
//       "The Feature Generation Tool creates a feature file from structured test case data, using predefined patterns. It outputs feature files compatible with behavior-driven development (BDD) frameworks, converting test cases into an executable format. ",
//     logo: "/assets/images/randon-logo.png",
//   },

//   {
//     name: "Load File Generator Tool",
//     functions: [
//         {
//     function: "generate_load_files_from_readme",
//     language: "python",
//     toolConfig: `def generate_load_files_from_readme(readme_output_path, load_file_output_directory, generate_load_file_flag):
//     try:
//         os.makedirs(load_file_output_directory, exist_ok=True)
//         json_generation_chain = get_json_chain(json_generation_template)

//         readme_files = glob.glob(os.path.join(readme_output_path, '*_README.md'))

//         load_files = []

//         for readme_file in readme_files:
//             with open(readme_file, 'r') as file:
//                 readme_text = file.read()

//             # extract scenario summary from readme file
//             print(f"\n\nExtracting Scenario data from the README file: {Path(readme_file).name}")
//             scenario_summary = extract_scenario_summary(readme_text)

//             json_output = ""
            
//             # generate the load file scenario information
//             for tok in json_generation_chain.stream({"input_text": scenario_summary}):
//                 print(tok, end="", flush=True)
//                 json_output += tok


//             json_data = json.loads(json_output)
//             scenario = json_data


//             load_filename = f"load_{os.path.basename(readme_file).replace('_README.md', '')}.xml"
//             load_filepath = os.path.join(load_file_output_directory, load_filename)

//             # Store the json filename
//             json_filename = f"{os.path.basename(readme_file).replace('_README.md', '')}.json"
//             json_filepath = os.path.join(load_file_output_directory, json_filename)

//             # Check if the load file needs to be generated
//             generate_load_file_flag = generate_load_file_flag.lower()
//             if generate_load_file_flag == "yes":
//                 # generate a load file 
//                 load_file_result = generate_loadfile_from_scenario(scenario=scenario)
//                 with open(load_filepath, 'w') as load_file:
//                     load_file.write(load_file_result_cleaned)
                
//             # Store the scenario data
//             scenario_data = {}
//             scenario_data["load_file_name"] = load_filename
//             scenario_data["message_type"]   = json_data["message_type"]
//             scenario_data["version"]        = json_data["version"]
//             scenario_data["scenario"]       = json_data["scenario"]
//             scenario_data["scheme"]         = json_data["scheme"]
//             scenario_data["flow"]           = json_data["flow"]
//             scenario_data["test_case"]      = json_data["test_case"]

//             load_files.append(scenario_data)

//             with open(json_filepath, 'w') as json_file:
//                 json.dump(scenario_data, json_file, indent = 4)

//         return load_files

//     except Exception as e:
//         logging.error(f"Failed to generate JSON files from README: {e}")
//         raise  
//         `,
//         }],
//     description:
//       "The Load File Generator Tool creates load files based on information extracted from README files. It identifies key details such as message type and payment scheme from the README content and generates structured load files (e.g., XML) for each test case.",
//     logo: "/assets/images/randon-logo.png",
//   },

//   {
//     name: "Feature Evaluation Tool",
//     functions: [
//         {
//     function: "evaluate_feature_file_quality",
//     language: "python",
//     toolConfig: `def evaluate_feature_file_quality(feature_file_result, structured_test_cases, pattern, evaluation_output_path):
//     try:
//         # Ensure the output directory exists, create it if it doesn't exist
//         os.makedirs(evaluation_output_path, exist_ok=True)

//         # Initialize the evaluation chain
//         feature_file_evaluation_chain = get_chain(feature_file_review_template)

//         for test_case in structured_test_cases:
//             # Retrieve the feature file content for the current test case
//             test_id = test_case.get("TestID", "UnknownID")
//             test_name = test_case.get("TestName", "UnknownTest")

//             # Check if the feature file exists in the generated feature files
//             if test_id not in feature_file_result:
//                 logging.warning(f"TestID {test_id} not found in generated feature files. Skipping evaluation.")
//                 continue

//             feature_file_content = feature_file_result[test_id]["content"]

//             # Evaluate the Feature file quality
//             feature_file_evaluation_result = ""
//             for tok in feature_file_evaluation_chain.stream(
//                     {"test_case": [test_case], "feature_file": feature_file_content, "pattern_file": pattern}):
//                 print(tok, end="", flush=True)
//                 feature_file_evaluation_result += tok

//             # Generate the filename for the evaluation result using TestID and TestName
//             filename = f"{test_id}_{test_name}_evaluation.md"
//             sanitized_filename = re.sub(r'[\\/*?:"<>|]', "_", filename)
//             filepath = os.path.join(evaluation_output_path, sanitized_filename)

//             # Write the evaluation result to the file
//             with open(filepath, 'w') as file:
//                 file.write(feature_file_evaluation_result)

//         logging.info("Feature file evaluation completed successfully.")

//     except Exception as e:
//         logging.error(f"Failed to evaluate feature file: {e}")
//         raise
//         `,
//         }],
//     description:
//       "This tool evaluates the quality and completeness of a generated feature file by comparing it to defined patterns. It assigns a quality score based on the evaluation, which helps determine the readiness of the feature file for testing.",
//     logo: "/assets/images/randon-logo.png",
//   },

//   {
//     name: "Squish Preparation Tool",
//     functions: [
//         {
//     function: "prepare_files_for_squish_execution",
//     language: "python",
//     toolConfig: `def prepare_files_for_squish_execution(generated_results_path, test_script_path, output_file_name, output_folder):
//     try:
//         # Constant for feature filename
//         FEATURE_FILENAME = "test.feature"

//         # Get all the files in the given directory
//         files = os.listdir(generated_results_path)

//         # Get all the feature files in the given directory
//         feature_files = []
//         for file in files:
//             if file.endswith(".feature"):
//                 feature_files.append(file)

//         # Store the path to the squish files folder
//         squish_folder = output_file_name
//         squish_folder_path = os.path.join(output_folder, squish_folder)

//         # Change the folder name if it already exists
//         squish_num = 1
//         squish_folder_with_num = squish_folder
//         while os.path.exists(squish_folder_path):
//             squish_folder_with_num = squish_folder + "_" + str(squish_num)
//             squish_folder_path = os.path.join(output_folder, squish_folder_with_num)
//             squish_num += 1
//         if squish_folder != squish_folder_with_num:
//             squish_folder = squish_folder_with_num

//         # Create the folder to store squish files
//         if not os.path.exists(squish_folder_path):
//             os.makedirs(squish_folder_path)

//         # Store all feature files with test scripts in seperate folders
//         for feature_file in feature_files:
//             # Create folders for each feature file
//             feature_folder  = feature_file.replace(".feature", "")
//             feature_folder_path = os.path.join(squish_folder_path, feature_folder)
//             if not os.path.exists(feature_folder_path):
//                 os.makedirs(feature_folder_path)

//             # Store a copy of the feature file
//             feature_file_path = os.path.join(generated_results_path, feature_file)
//             shutil.copy2(feature_file_path, feature_folder_path)

//             # Store a copy of the test script
//             shutil.copy2(test_script_path, feature_folder_path)

//             # Rename the feature file
//             current_feature_file_path = os.path.join(feature_folder_path, feature_file)
//             new_feature_file_path = os.path.join(feature_folder_path, FEATURE_FILENAME)
//             os.rename(current_feature_file_path, new_feature_file_path)

//         # Store the name of the squish archive 
//         squish_file = squish_folder

//         # Change the current working directory to the output folder
//         os.chdir(output_folder)
        
//         # Change the file name if it already exists
//         squish_num = 1
//         squish_file_with_num = squish_file
//         while os.path.isfile(squish_file_with_num + ".zip"):
//             squish_file_with_num = squish_file + "_" + str(squish_num)
//             squish_num += 1
//         if squish_file != squish_file_with_num:
//             squish_file = squish_file_with_num

//         # Create an archive with the squish files
//         shutil.make_archive(squish_file, 'zip', squish_folder_path)

//     except Exception as e:
//         logging.error(f"Failed to prepare squish files: {e}")
//         raise  
//         `,
//         }],
//     description:
//       "The Squish Preparation Tool organizes test case files and scripts to prepare them for execution in the Squish testing framework. It ensures that all necessary files are correctly formatted and stored in the required output directory, ready for automated testing.",
//     logo: "/assets/images/randon-logo.png",
//   },

  {
    "name": "Bean Analysis Tool",
    "functions": [
        {
            "function": "analyze_bean",
            "language": "python",
            "toolConfig": `def analyze_bean(bean):
    try:
        bean_analysis_chain = bean_analysis_prompt | llm | StrOutputParser()
        result = ""
        for tok in bean_analysis_chain.stream({"bean": bean}):
            print(tok, end="", flush=True)
            result += tok
        return mdformat.text(result)
    except Exception as e:
        logging.error(f"Failed to analyze bean: {e}")
        raise`
        }
    ],
    "description": "Analyzes an EJB bean to extract details such as class name, properties, constructors, and methods, and generates a structured markdown output.",
    "logo": "/assets/images/bean-analysis-logo.png"
  },

  {
    "name": "Proto File Generator Tool",
    "functions": [
        {
            "function": "generate_proto_file",
            "language": "python",
            "toolConfig": `def generate_proto_file(bean, models):
    try:
        proto_chain = proto_prompt | llm | StrOutputParser()
        result = ""
        for tok in proto_chain.stream({"bean": bean, "models": models}):
            print(tok, end="", flush=True)
            result += tok
        return mdformat.text(result)
    except Exception as e:
        logging.error(f"Failed to generate .proto file from bean and models: {e}")
        raise`
        }
    ],
    "description": "Generates a .proto file based on EJB bean methods and model definitions for gRPC services.",
    "logo": "/assets/images/proto-file-generator-logo.png"
  },

  {
    "name": "gRPC Service Generator Tool",
    "functions": [
        {
            "function": "generate_grpc_service_java",
            "language": "python",
            "toolConfig": `def generate_grpc_service_java(bean, proto_result, output_path):
    try:
        java_service_chain = java_service_prompt | llm | StrOutputParser()
        result = ""
        for tok in java_service_chain.stream({"bean": bean, "proto": proto_result}):
            print(tok, end="", flush=True)
            result += tok
        formatted_result = mdformat.text(result)
        write_file(output_path, formatted_result)
        return formatted_result
    except Exception as e:
        logging.error(f"Failed to generate gRPC service Java implementation: {e}")
        raise`
        }
    ],
    "description": "Generates the Java implementation for gRPC services based on an EJB bean and a .proto file.",
    "logo": "/assets/images/grpc-service-generator-logo.png"
  },

  {
    "name": "gRPC ServerClient Generator Tool",
    "functions": [
        {
            "function": "generate_grpc_server_client_java",
            "language": "python",
            "toolConfig": `def generate_grpc_server_client_java(proto_result, service_java_result, output_path):
    try:
        grpc_server_client_chain = ejb2grpc_server_client_template | llm | StrOutputParser()
        result = ""
        for tok in grpc_server_client_chain.stream({"proto": proto_result, "service": service_java_result}):
            print(tok, end="", flush=True)
            result += tok
        formatted_result = mdformat.text(result)
        write_file(output_path, formatted_result)
        return formatted_result
    except Exception as e:
        logging.error(f"Failed to generate gRPC server and client Java code: {e}")
        raise`
        }
    ],
    "description": "Generates Java implementations for both gRPC server and client, enabling seamless communication based on the .proto file and service implementation.",
    "logo": "/assets/images/grpc-serverclient-logo.png"
  },

  {
    "name": "Generated Code Reviewer Tool",
    "functions": [
        {
            "function": "review_generated_code",
            "language": "python",
            "toolConfig": `def review_generated_code(code, output_path):
    try:
        review_chain = review_prompt | llm | StrOutputParser()
        result = ""
        for tok in review_chain.stream({"code": code}):
            print(tok, end="", flush=True)
            result += tok
        formatted_result = mdformat.text(result)
        with open(output_path, 'w') as f:
            f.write(formatted_result)
        return formatted_result
    except Exception as e:
        logging.error(f"Failed to review generated code: {e}")
        raise`
        }
    ],
    "description": "Reviews the generated code for correctness, efficiency, and adherence to best practices, and outputs a structured review report.",
    "logo": "/assets/images/code-reviewer-logo.png"
  },
  
  {
    "name": "Generated Code Scorer Tool",
    "functions": [
        {
            "function": "score_generated_code",
            "language": "python",
            "toolConfig": `def score_generated_code(code, output_path):
    try:
        score_chain = score_prompt | llm | StrOutputParser()
        result = ""
        for tok in score_chain.stream({"code": code}):
            print(tok, end="", flush=True)
            result += tok
        formatted_result = mdformat.text(result)
        with open(output_path, 'w') as f:
            f.write(formatted_result)
        return formatted_result
    except Exception as e:
        logging.error(f"Failed to score generated code: {e}")
        raise`
        }
    ],
    "description": "Evaluates and scores the generated code based on quality, functionality coverage, and adherence to best practices.",
    "logo": "/assets/images/code-scorer-logo.png"
  },

  {
    "name": "Analyze DAL Java Code Tool",
    "functions": [
      {
        "function": "analyze_dataaccess_layer",
        "language": "python",
        "toolConfig": `def analyze_dataaccess_layer(java_code_path, analysis_output_path):
      try:
          java_code = java_code_path
          analysis_result = ""
          for tok in data_access_analysis_chain.stream({"java_code": java_code}):
              print(tok, end="", flush=True)
              analysis_result += tok
          analysis_result = mdformat.text(analysis_result)
          write_file(analysis_output_path, analysis_result)
          return analysis_result
      except Exception as e:
          logging.error(f"Failed to analyze data access layer: {e}")
          raise`
      }
    ],
    "description": "Analyzes Oracle data access layer (DAL) code to extract methods, stored procedures, and functions for conversion planning.",
    "logo": "/assets/images/analyze-dal-logo.png"
  },
  {
    "name": "Analyze Oracle Package Tool",
    "functions": [
      {
        "function": "analyze_oracle_package",
        "language": "python",
        "toolConfig": `def analyze_oracle_package(oracle_package_path, sp_analysis_output_path):
      try:
          oracle_package = oracle_package_path
          analysis_result = ""
          for tok in oracle_package_chain.stream({"oracle_package": oracle_package}):
              print(tok, end="", flush=True)
              analysis_result += tok
          analysis_result = mdformat.text(analysis_result)
          write_file(sp_analysis_output_path, analysis_result)
          return analysis_result
      except Exception as e:
          logging.error(f"Failed to analyze Oracle package: {e}")
          raise`
      }
    ],
    "description": "Analyzes Oracle schemas, stored procedures, and functions to extract structure and relationships for MongoDB conversion.",
    "logo": "/assets/images/analyze-oracle-package-logo.png"
  },
  {
    "name": "Create MongoDB Schema Tool",
    "functions": [
      {
        "function": "create_mongodb_schema",
        "language": "python",
        "toolConfig": `def create_mongodb_schema(oracle_package_path, ddl_scripts_path, schema_output_path):
      try:
          oracle_package = oracle_package_path
          ddl_scripts = ddl_scripts_path
          schema_result = ""
          for tok in combined_schema_chain.stream({"oracle_package": oracle_package, "ddl_scripts": ddl_scripts}):
              print(tok, end="", flush=True)
              schema_result += tok
          write_file(schema_output_path, schema_result)
          return schema_result
      except Exception as e:
          logging.error(f"Failed to create MongoDB schema: {e}")
          raise`
      }
    ],
    "description": "Generates a MongoDB schema using Oracle schema analysis and DDL scripts, leveraging document-based design.",
    "logo": "/assets/images/mongodb-schema-logo.png"
  },
  {
    "name": "Generate MongoDB DAL Tool",
    "functions": [
      {
        "function": "generate_mongo_dataaccess_layer",
        "language": "python",
        "toolConfig": `def generate_mongo_dataaccess_layer(mongodb_schema_result, oracle_package_path, java_code_path, mongo_dataaccess_output_path):
      try:
          oracle_package = oracle_package_path
          java_code = java_code_path
          dataaccess_result = ""
          for tok in mongo_dataaccess_chain.stream({"mongodb_schema": mongodb_schema_result, "oracle_package": oracle_package, "java_code": java_code}):
              print(tok, end="", flush=True)
              dataaccess_result += tok
          write_file(mongo_dataaccess_output_path, dataaccess_result)
          return dataaccess_result
      except Exception as e:
          logging.error(f"Failed to generate MongoDB data access layer: {e}")
          raise`
      }
    ],
    "description": "Refactors Oracle data access layer to MongoDB by generating model classes and repository interfaces.",
    "logo": "/assets/images/mongo-dal-logo.png"
  },
  {
    "name": "Review Generated DAL Tool",
    "functions": [
      {
        "function": "review_generated_dal_code",
        "language": "python",
        "toolConfig": `def review_generated_code(oracle_package_path, java_code_path, mongodb_schema_result, mongo_dataaccess_result, review_output_path):
      try:
          oracle_package = oracle_package_path
          java_code = java_code_path
          review_result = ""
          for tok in review_chain.stream({"mongodb_schema": mongodb_schema_result,
                                          "generated_java_code": mongo_dataaccess_result,
                                          "oracle_package": oracle_package,
                                          "legacy_java_code": java_code}):
              print(tok, end="", flush=True)
              review_result += tok
          write_file(review_output_path, review_result)
          return review_result
      except Exception as e:
          logging.error(f"Failed to review generated code: {e}")
          raise`
      }
    ],
    "description": "Reviews the refactored MongoDB DAL code for correctness, efficiency, and adherence to best practices.",
    "logo": "/assets/images/review-dal-logo.png"
  },
  {
    "name": "Score Generated DAL Tool",
    "functions": [
      {
        "function": "score_generated_dal_code",
        "language": "python",
        "toolConfig": `def score_generated_code(oracle_package_path, java_code_path, mongodb_schema_result, mongo_dataaccess_result, score_output_path):
      try:
          oracle_package = oracle_package_path
          java_code = java_code_path
          score_result = ""
          for tok in score_chain.stream({"mongodb_schema": mongodb_schema_result,
                                          "generated_java_code": mongo_dataaccess_result,
                                          "oracle_package": oracle_package,
                                          "legacy_java_code": java_code}):
              print(tok, end="", flush=True)
              score_result += tok
          write_file(score_output_path, score_result)
          return score_result
      except Exception as e:
          logging.error(f"Failed to score generated code: {e}")
          raise`
      }
    ],
    "description": "Scores the refactored MongoDB DAL code for quality, functionality coverage, and adherence to standards.",
    "logo": "/assets/images/score-dal-logo.png"
  }
  //   {
  //     name: '',
  //     function: '',
  //     language: 'python',
  //     toolConfig: ``,
  //   },
];
